import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';

import { AngularFireModule } from "@angular/fire/compat";
import { AngularFireAuthModule } from "@angular/fire/compat/auth";

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
// import { SelectionComponent } from './selection/selection.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ImageCropperModule } from './image-cropper/image-cropper.module';

import { MatCardModule } from '@angular/material/card';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';
import { MatTableModule } from '@angular/material/table';
import { MatExpansionModule } from '@angular/material/expansion';

import { MainComponent } from './main/main.component';
import { SingleComponent } from './components/single/single.component';
import { DoubleComponent } from './components/double/double.component';
import { ModalComponent } from './components/modal/modal.component';
import { ChangeSizeComponent } from './components/modal/change-size/change-size.component';

import { MAT_COLOR_FORMATS, NgxMatColorPickerModule, NGX_MAT_COLOR_FORMATS } from '@angular-material-components/color-picker';
import { SelectBackgroundComponent } from './components/modal/select-background/select-background.component';
import { AlertComponent } from './components/modal/alert/alert.component';
import { ProgressComponent } from './components/modal/progress/progress.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { HomeComponent } from './dashboard/home/home.component';
import { StandardComponent } from './layout/standard/standard.component';
import { environment } from "../../src/environments/environment";
import { SignInComponent } from './components/sign-in/sign-in.component';
import { SignUpComponent } from './components/sign-up/sign-up.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { VerifyEmailComponent } from './components/verify-email/verify-email.component';
// Auth service
import { AuthService } from "./shared/services/auth.service";
import { GedcomComponent } from './dashboard/gedcom/gedcom.component';
import { OrdersComponent } from './dashboard/orders/orders.component';
import { DesignsComponent } from './dashboard/designs/designs.component';
import { ProfileComponent } from './dashboard/profile/profile.component';
import { SelectionComponent } from './dashboard/selection/selection.component';
import { OrderprintComponent } from './components/modal/orderprint/orderprint.component';

import { CarouselModule } from 'ngx-bootstrap/carousel';
import { CheckoutComponent } from './components/modal/checkout/checkout.component';
import { ShoppingComponent } from './components/modal/shopping/shopping.component';
import { MobileFooterComponent } from './components/mobile-footer/mobile-footer.component';
import { SaveDesignDialogComponent } from './components/save-design-dialog/save-design-dialog.component';
import { PreviewComponent } from './components/modal/preview/preview.component';

import { ImageProcessComponent } from './components/modal/image-process/image-process.component';

import { CheckwarningComponent } from './components/modal/checkwarning/checkwarning.component';
import { ViewwarningComponent } from './components/modal/viewwarning/viewwarning.component';
import { DeletedesignComponent } from './components/modal/deletedesign/deletedesign.component';

import { AngularFireStorageModule } from "@angular/fire/compat/storage";
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { FileAlertComponent } from './components/alerts/file-alert/file-alert.component';
import { LanguageSelectionComponent } from './components/language-selection/language-selection.component';
import { NewsComponent } from './dashboard/news/news.component';
import { CustomerInfoComponent } from './components/customer-info/customer-info.component';
import { OrderConfirmationComponent } from './service/order-confirmation/order-confirmation.component';
import { OrderFailedComponent } from './service/order-failed/order-failed.component';
import { AdminOrdersComponent } from './admin-orders/admin-orders.component';
import { SelectStockGEDCOMComponent } from './components/modal/select-stock-gedcom/select-stock-gedcom.component';
import { AssistancePackageComponent } from './dashboard/assistance-package/assistance-package.component';
import { BuyAssistancePackageComponent } from './components/buy-assistance-package/buy-assistance-package.component';
import { SelectAssistancePackageComponent } from './components/select-assistance-package/select-assistance-package.component';
import { ConfirmChangeEmailComponent } from './components/modal/confirm-change-email/confirm-change-email.component';
import { EmailChangeFailComponent } from './components/modal/email-change-fail/email-change-fail.component';
import { WizardComponent } from './components/wizard/wizard.component';
import { ProfileFormComponent } from './components/profile-form/profile-form.component';
import { GedcomUploadComponent } from './components/gedcom-upload/gedcom-upload.component';
import { WizardGedcomComponent } from './components/wizard/wizard-gedcom/wizard-gedcom.component';

import { DBConfig, NgxIndexedDBModule } from 'ngx-indexed-db';
import { DeleteGedcomComponent } from './components/modal/delete-gedcom/delete-gedcom.component';
import { CurrencyConverterComponent } from './components/currency-converter/currency-converter.component';
import { EmailSubscribeComponent } from './components/modal/email-subscribe/email-subscribe.component';
import { BookingAssistancePackageComponent } from './components/modal/booking-assistance-package/booking-assistance-package.component';
import { VerifyReservationComponent } from './components/modal/verify-reservation/verify-reservation.component';
import { ReservationConfirmationComponent } from './components/modal/reservation-confirmation/reservation-confirmation.component';
import { ConfirmDesignTermsComponent } from './components/modal/confirm-design-terms/confirm-design-terms.component';
import { WizardTreeSelectionComponent } from './components/wizard/wizard-tree-selection/wizard-tree-selection.component';

const dbConfig: DBConfig = {
  name: 'ancytree',
  version: 1,
  objectStoresMeta: [{
    store: 'nodes',
    storeConfig: { keyPath: 'id', autoIncrement: false },
    storeSchema: [
      { name: 'nodeinfos', keypath: 'nodeinfos', options: { unique: false } },
      { name: 'coupleinfos', keypath: 'coupleinfos', options: { unique: false } }
    ]
  }]
};

const config = {
  apiKey: environment.firebase.apiKey,
  authDomain: environment.firebase.authDomain,
  databaseURL: environment.firebase.databaseURL,
  projectId: environment.firebase.projectId,
  storageBucket: environment.firebase.storageBucket,
  messagingSenderId: environment.firebase.messagingSenderId
};

@NgModule({
  declarations: [
    AppComponent,
    SelectionComponent,
    MainComponent,
    SingleComponent,
    DoubleComponent,
    ModalComponent,
    ChangeSizeComponent,
    SignInComponent,
    SignUpComponent,
    ForgotPasswordComponent,
    VerifyEmailComponent,
    SelectBackgroundComponent,
    AlertComponent,
    ProgressComponent,
    NavbarComponent,
    SidebarComponent,
    HomeComponent,
    StandardComponent,
    GedcomComponent,
    OrdersComponent,
    DesignsComponent,
    ProfileComponent,
    OrderprintComponent,
    CheckoutComponent,
    ShoppingComponent,
    MobileFooterComponent,
    SaveDesignDialogComponent,
    PreviewComponent,
    ImageProcessComponent,
    CheckwarningComponent,
    ViewwarningComponent,
    DeletedesignComponent,
    FileAlertComponent,
    LanguageSelectionComponent,
    NewsComponent,
    CustomerInfoComponent,
    OrderConfirmationComponent,
    OrderFailedComponent,
    AdminOrdersComponent,
    SelectStockGEDCOMComponent,
    AssistancePackageComponent,
    BuyAssistancePackageComponent,
    SelectAssistancePackageComponent,
    DeleteGedcomComponent,
    CurrencyConverterComponent,
    ConfirmChangeEmailComponent,
    EmailChangeFailComponent,
    EmailSubscribeComponent,
    BookingAssistancePackageComponent,
    VerifyReservationComponent,
    ReservationConfirmationComponent,
    ConfirmDesignTermsComponent,
    WizardComponent,
    ProfileFormComponent,
    GedcomUploadComponent,
    WizardGedcomComponent,
    WizardTreeSelectionComponent,
  ],
  imports: [
    ImageCropperModule,
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    NgxIndexedDBModule.forRoot(dbConfig),
    HttpClientModule,
    BrowserAnimationsModule,
    MatCardModule,
    MatRadioModule,
    MatSelectModule,
    MatButtonModule,
    MatGridListModule,
    FormsModule,
    MatToolbarModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    MatCheckboxModule,
    MatDialogModule,
    MatInputModule,
    MatFormFieldModule,
    NgxMatColorPickerModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatSidenavModule,
    MatListModule,
    AngularFireModule.initializeApp(config),
    AngularFirestoreModule,
    AngularFireAuthModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatExpansionModule,
    CarouselModule.forRoot(),
  ],
  providers: [
    AuthService,
    { provide: MAT_COLOR_FORMATS, useValue: NGX_MAT_COLOR_FORMATS }
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
